import React, { useEffect, useMemo, useState } from "react";
import {
    useGetCustomerByIdQuery,
} from "../customerApi";
import { useGetEnumsQuery } from "../../../app/globalApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { getEnumDisplayNameByConstant } from "../../../helpers/utils/EnumUtils";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { Tabs } from "react-simple-tabs-component";
import ReswareTypeMapping from "./ReswareTypeMapping";
import ReswareCredentials from "./ReswareCredentials";
import SuperMarket from "./SuperMarket";

const Integrations = () => {

    let { customerId } = useParams();

    document.title = `Integrations`;

    const customerQuery = useGetCustomerByIdQuery(customerId ?? skipToken);
    const { data: enums } = useGetEnumsQuery("");

    const [customerData, setCustomerData] = useState<any>({});

    useEffect(() => {
        let customerObj = customerQuery?.data;
        if (customerObj) {
            setCustomerData({
                ...customerObj,
                contactStrategy: customerObj.contactStrategy ? {
                    value: customerObj.contactStrategy,
                    label: getEnumDisplayNameByConstant(enums?.["ContactStrategy"], customerObj.contactStrategy)
                } : null,
                customerType: customerObj.customerType ? {
                    value: customerObj.customerType,
                    label: getEnumDisplayNameByConstant(enums?.["CustomerType"], customerObj.customerType)
                } : null,
                billingType: customerObj.billingType ? {
                    value: customerObj.billingType,
                    label: getEnumDisplayNameByConstant(enums?.["BillingType"], customerObj.billingType)
                } : null,
                region: customerObj?.region ? {
                    value: customerObj?.region?.id,
                    label: customerObj?.region?.name
                } : null,
                parentCustomerReference: customerObj?.parentCustomerReference ? {
                    value: customerObj.parentCustomerReference?.id,
                    label: customerObj.parentCustomerReference?.customerName
                } : null,
            })
        }
    }, [customerQuery?.data]);




    // Compute bottomTabs using useMemo
    const bottomTabs = useMemo(() => {
        const result: any[] = [];
        if (hasPermission(["RESW-V"])) {
            result.push({
                label: 'Resware Credentials',
                Component: ReswareCredentials
            });
        }
        if (hasPermission(["RESW-V"])) {
            result.push({
                label: 'Resware Type Mappings',
                Component: ReswareTypeMapping
            });
        }
        if (hasPermission(["CUST-R"])) {
            result.push({
                label: 'Super Market',
                Component: SuperMarket
            });
        }
        return result;
    }, [customerData.parentCustomer, customerData?.customerLevel]);


    return (
        <>
            <Tabs tabs={bottomTabs} className="bootstrap-tabs-component mt-5" />
        </>
    )
}
export default Integrations;